'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMLabelNew = require('./OMLabelNew.scss');var _OMLabelNew2 = _interopRequireDefault(_OMLabelNew);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMLabelNew = function OMLabelNew(props) {return (
    _react2.default.createElement('div', {
        className: (0, _classnames2.default)(_OMLabelNew2.default.label, _OMLabelNew2.default[props.className]),
        title: props.title,
        style: props.color ? { backgroundColor: props.color } : {} },

      props.isMobile && props.inMultiPin ? null : _react2.default.createElement('span', null, props.label)));};



OMLabelNew.propTypes = {
  label: _propTypes2.default.string,
  title: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  inMultiPin: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  className: _propTypes2.default.string };exports.default =


OMLabelNew;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMLabelNew/OMLabelNew.js
// module id = 2748
// module chunks = 0